<template>
  <div id="appRoot">
    <template v-if="isLoginPage">
      <router-view :key="$route.fullpath"></router-view>
    </template>
    <template v-else>
      <v-app class="app">
        <app-drawer @toggle-chatbot="chatbotOpen = !chatbotOpen"></app-drawer>
        <switch-session-bar />
        <acting-grupo-bar />
        <acting-dealer-bar />
        <subscription-warning-bar />
        <app-toolbar></app-toolbar>
        <v-main>
          <app-page-header v-if="$route.meta.breadcrumb"></app-page-header>
          <div v-else style="min-height: 26px;"></div>

          <div class="page-wrapper" style="min-height: calc(100% - 120px);">
            <router-view style="padding-left: 10px;"></router-view>
          </div>

          <v-footer height="auto" class="pa-5">
            <span class="text-caption" style="padding-left: 10px;">&copy; {{ new Date().getFullYear() }}</span>
          </v-footer>
        </v-main>
        <app-fab></app-fab>
        <chat-bot v-model="chatbotOpen"></chat-bot>
        <toaster></toaster>
      </v-app>
    </template>
  </div>
</template>

<script>
import AppDrawer from './theme/components/AppDrawer'
import AppToolbar from './theme/components/AppToolbar'
import AppPageHeader from './theme/components/AppPageHeader'
import AppFab from './theme/components/AppFab'
import ChatBot from './components/ChatBot'
import Toaster from './components/Toaster'
import SwitchSessionBar from './theme/components/SwitchSessionBar'
import ActingDealerBar from './theme/components/ActingDealerBar'
import ActingGrupoBar from './theme/components/ActingGrupoBar'
import SubscriptionWarningBar from './theme/components/SubscriptionWarningBar'

export default {
  name: 'App',

  components: {
    AppDrawer,
    AppToolbar,
    AppPageHeader,
    AppFab,
    ChatBot,
    Toaster,
    SwitchSessionBar,
    ActingDealerBar,
    ActingGrupoBar,
    SubscriptionWarningBar
  },

  data: () => ({
    chatbotOpen: false,
    firmando: false,
    themes: [
      {
        text: 'Light',
        value: 'light',
        colors: [
          '#ffffff', '#f5f5f5', '#c0c0c0'
        ]
      }
      /* {
        text: 'Dark',
        value: 'dark',
        colors: [
          '#424242', '#616161', '#757575'
        ]
      },
      {
        text: 'Blue',
        value: 'blue',
        colors: [
          '#bbdefb', '#64b5f6', '#1e88e5'
        ]
      },
      {
        text: 'Green',
        value: 'green',
        colors: [
          '#a5d6a7', '#66bb6a', '#388e3c'
        ]
      },
      {
        text: 'Red',
        value: 'red',
        colors: [
          '#ff5252', '#ff1744', '#d50000'
        ]
      } */
    ]
  }),

  computed: {
    isLoginPage () {
      if (!this.$route.name) return true
      return this.$route.name === 'Escaneo' || this.$route.name === 'Login' || this.$route.name === 'Payment' || this.$route.name === 'Password' || this.$route.name === 'Suscripción expirada' || this.$route.name === 'Landing'
    }
  },

  created () {
    window.app = this
      // Verificar si estamos en una sesión cambiada al iniciar
  if (localStorage.getItem('switch_session_mode') === 'true') {
    console.log('Detectada sesión cambiada en App.vue')
    this.$store.commit('SET_SWITCH_SESSION_MODE', true)
    
    // Asegurarse de que el usuario está cargado
    if (!this.$store.getters.CURRENT_USER || !this.$store.getters.CURRENT_USER.email) {
      this.$store.dispatch('LOAD_CURRENT_USER')
    }
  }
  
  // Si hay un token válido pero no tenemos datos completos del usuario (como dealer), recargarlos
  if (this.$store.getters.LOGGED_IN && this.$store.getters.CURRENT_USER) {
    const currentUser = this.$store.getters.CURRENT_USER
    // Si solo tenemos campos básicos (first_name, last_name, email) pero no el name completo o dealer
    if (!currentUser.dealer || !currentUser.name || !currentUser.dealer.balance) {
      console.log('Recargando datos completos del usuario...')
      this.$store.dispatch('RELOAD_USER_DATA').then(success => {
        if (success) {
          console.log('Datos del usuario recargados exitosamente')
        } else {
          console.log('No se pudieron recargar los datos del usuario')
        }
      })
    }
  }
  },

  mounted () {
    const newTheme = localStorage.getItem('theme')
    if (newTheme) {
      this.$vuetify.theme.dark = newTheme === 'dark'
      if (newTheme !== 'dark' && newTheme !== 'light') {
        const theme = this.themes.find(theme => theme.value === newTheme)
        if (theme) {
          this.$vuetify.theme.themes.light.primary = theme.colors[1]
          this.$vuetify.theme.themes.light.secondary = theme.colors[0]
          this.$vuetify.theme.themes.light.accent = theme.colors[2]
        }
      }
    }
  }
}
</script>

<style>
/* #app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
} */

.v-data-table {
  border-radius: 20px !important;
}

.v-card {
  border-radius: 20px !important;
}
/* Ajustar el posicionamiento de barras de sistema */
.v-application .v-system-bar:nth-of-type(1) {
  top: 0 !important;
  z-index: 6;
}

.v-application .v-system-bar:nth-of-type(2) {
  top: 40px !important;  /* Altura de la primera barra */
  z-index: 5;
}

/* Ajustar la app-bar - MODIFICAR ESTAS REGLAS */
.v-application .v-app-bar {
  top: 0 !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Si hay al menos una barra */
.v-application .v-system-bar + .v-app-bar {
  top: 40px !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Si hay dos barras */
.v-application .v-system-bar + .v-system-bar + .v-app-bar {
  top: 80px !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
}

/* Eliminar espacio entre barras y contenido */
.v-application .v-system-bar {
  margin: 0 !important;
  padding: 0 12px !important; /* Mantener solo el padding horizontal */
  height: 40px !important; /* Asegurar altura exacta */
  display: flex;
  align-items: center;
}

/* Ajustar el contenido de las barras para centrado vertical */
.v-application .v-system-bar > * {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* Asegurar que el app-bar se ajuste perfectamente debajo de las barras de sistema */
.v-application .v-app-bar.v-app-bar--fixed {
  transition: none !important; /* Evitar animaciones que puedan causar saltos */
}
</style>
